import React, { useEffect, useState } from 'react'
import { Button, Typography } from 'antd'

const LS_KEY = 'cookieConsent'

const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const consent = localStorage.getItem(LS_KEY)
    if (consent !== 'true') {
      setVisible(true)
    }
  }, [])

  const accept = () => {
    localStorage.setItem(LS_KEY, 'true')
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        background: '#001529',
        padding: '12px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        flexWrap: 'wrap'
      }}
    >
      <Typography.Text style={{ color: '#fff', margin: 0 }}>
        Мы используем cookie-файлы для улучшения работы сайта. Продолжая использование, вы соглашаетесь с этим.
      </Typography.Text>
      <Button type="primary" size="small" onClick={accept}>
        Принять
      </Button>
    </div>
  )
}

export default CookieConsent
